import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import { get } from "lodash";
import { Paper } from "@material-ui/core";
import NoResult from "src/features/Components/NoResults";
import moment from "moment";
import { withComma, fixed2 } from "src/features/Utils/price";
import Status from "./status";
import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { deletePromo, stopPromo, fetchDetail } from "../ducks";
import { useDispatch, useSelector } from "react-redux";
import useNotification from "src/features/Notification/customs";

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontWeight: "bold",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
}))(TableRow);

const StyledButton = styled(IconButton)`
  border: 1px solid #bbb;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  table_container: {
    position: "relative",
  },
  table: {
    minWidth: 700,
  },
  table_head: {
    backgroundColor: "#F5F5F5",
  },
  generics: {
    whiteSpace: "nowrap",
    width: 450,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  icon: { width: 25, height: 25 },
}));

export default function CustomizedTables({ promotions }) {
  const classes = useStyles();
  const detail = useSelector((state) => state.supply.detail);
  const dispatch = useDispatch();
  const { showError, showSuccess } = useNotification();

  const handleStopPromo = async (_id) => {
    let r = window.confirm("Do you want to stop this promotion?");
    if (r === true) {
      try {
        await dispatch(stopPromo(_id, { end_date: moment() }));
        await dispatch(fetchDetail(detail._id));
        showSuccess();
      } catch (error) {
        showError(error);
      }
    }
  };

  const handleDeletePromo = async (_id) => {
    let r = window.confirm("Do you want to delete this promotion?");
    if (r === true) {
      try {
        await dispatch(deletePromo(_id));
        await dispatch(fetchDetail(detail._id));
        showSuccess();
      } catch (error) {
        showError(error);
      }
    }
  };

  return (
    <Paper elevation={0} className={classes.root}>
      <TableContainer className={classes.table_container} component={"div"}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow className={classes.table_head}>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
              <StyledTableCell>Promo Price</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {promotions.map((row) => (
              <StyledTableRow key={row._id}>
                <StyledTableCell component="th" scope="row">
                  {moment(row.start_date).format("DD/MM/YYYY")}
                </StyledTableCell>
                <StyledTableCell>
                  {moment(row.end_date).format("DD/MM/YYYY")}
                </StyledTableCell>
                <StyledTableCell>
                  ฿{withComma(fixed2(get(row, "promo_price", 0)))}
                </StyledTableCell>
                <StyledTableCell>
                  <Status status={row.status} />
                </StyledTableCell>
                <StyledTableCell align="center">
                  <StyledButton
                    size="small"
                    disabled={row.status !== "active"}
                    onClick={() => handleStopPromo(row._id)}
                  >
                    <StopIcon className={classes.icon} />
                  </StyledButton>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <StyledButton
                    size="small"
                    disabled={row.status !== "upcoming"}
                    onClick={() => handleDeletePromo(row._id)}
                  >
                    <CloseIcon className={classes.icon} />
                  </StyledButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!!!promotions.length && <NoResult text="No promotion available" />}
    </Paper>
  );
}
